const Constants = {
  baseMapUrl:
    "https://services1.arcgisonline.co.nz/arcgis/rest/services/Imagery/newzealand/MapServer",
  propertySearchLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/RM_PropertySearch/FeatureServer/1",

  aerialTileLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/CommonMapServices/Aerial_Foreground/MapServer",

  propertyTileLayer:
    "https://gisapps.tauranga.govt.nz/arcgis/rest/services/Basemaps/AerialForeground/MapServer",

  contourTilesLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/GPSIT_Contour_1m_2022_NZVD16/MapServer",

  introductionText:
    "This tool allows you to view a range of harbour inundation scenarios generated by various extreme storm events and potential sea level rise through to 2130.  You can find a specific property, view a general area, or see the entire city.",

  step1Text: "Select Hazard Timeframe",
  step2Text: "Select Sea Level Rise Scenario (metres above NZVD 16)",
  step3Text: "Select Likelihood of Storm Event (Annual Exceedance Probability)",

  slr1Title: "Current",
  slr1Text:
    "This group of data presents the extent of inundation based on the current sea level, and the impact of three extreme storm events with present day annual exceedance probability (AEP) likelihoods of 2%, 1% and 0.2 %.  Note: A 1% AEP event has a 1% chance of occurring in any year.",
  slr2Title: "Year 2070/2080",
  slr2Text:
    "This group of data presents the extent of inundation based on two SLR scenarios out to 2070/2080 0.2m and 0.4m.  The impacts of one storm event, with 1% AEP is provided based on the chosen SLR.",

  slr3Title: "Year 2130",
  slr3Text:
    "This group of data presents the extent of inundation based on three SLR scenarios out to 2130 0.6 m, 1.05m and 1.4m.  The impacts of three storm events with 2%, 1% and 0.2% AEPs are provided based on the chosen SLR.",

  notesTitle: "Note:",
  notesText:
    "Different properties are exposed to different levels of probability that the hazard will in fact occur, and that the sea level rise scenarios assessed have their own uncertainty. The reports and modelling results are undertaken at a local scale and may be superseded by site specific, detailed assessments undertaken by qualified and experienced practitioners using improved or higher resolution data than presented in this study or by the presence of suitably designed, constructed and maintained protection structures.",

  legendTitle: "Depth (metres above existing ground level)",
  legendData: [
    {
      color: "#d1efff",
      label: "0.1 to 0.25m",
    },
    {
      color: "#4cd6ff",
      label: "0.25 to 0.5m",
    },
    {
      color: "#4c679d",
      label: "0.5 to 1.00m",
    },
    {
      color: "#edb74c",
      label: "Above 1m",
    },
  ],
  slrTitle: "Sea level rise",
  stormSurgeTitle: "Storm Event Likelihood",
  contourLayerWidgetTitle: "Contour layer",
};

const year0 = "Current";
const year1 = "2070/2080";
const year2 = "2130";

const slr0 = "Current";
const slr1 = "0.2 metres";
const slr2 = "0.4 metres";
const slr3 = "0.6 metres";
const slr4 = "1.05 metres";
const slr5 = "1.4 metres";

const stormEventLevel0 = "None";
const stormEventLevel1 = "2% AEP";
const stormEventLevel2 = "1% AEP";
const stormEventLevel3 = "0.2% AEP";

export const innudationLayerURL =
  "https://gis.tauranga.govt.nz/server/rest/services/RiskMaps_Inundation/MapServer";

export const contourTilesLayerTitle = "contours";

export const dataObject = [
  {
    label: year0,
    seaLevels: [
      {
        label: slr0,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: null,
          },
          {
            label: stormEventLevel1,
            subLayer: 5,
          },
          {
            label: stormEventLevel2,
            subLayer: 7,
          },
          {
            label: stormEventLevel3,
            subLayer: 13,
          },
        ],
      },
    ],
  },
  {
    label: year1,
    seaLevels: [
      {
        label: slr1,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: 0,
          },
          {
            label: stormEventLevel2,
            subLayer: 8,
          },
        ],
      },
      {
        label: slr2,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: 1,
          },
          {
            label: stormEventLevel2,
            subLayer: 9,
          },
        ],
      },
    ],
  },
  {
    label: year2,
    seaLevels: [
      {
        label: slr3,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: 2,
          },
          {
            label: stormEventLevel2,
            subLayer: 10,
          },
        ],
      },
      {
        label: slr4,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: 3,
          },
          {
            label: stormEventLevel1,
            subLayer: 6,
          },
          {
            label: stormEventLevel2,
            subLayer: 11,
          },
        ],
      },
      {
        label: slr5,
        stormEvents: [
          {
            label: stormEventLevel0,
            subLayer: 4,
          },
          {
            label: stormEventLevel2,
            subLayer: 12,
          },
        ],
      },
    ],
  },
];

export default Constants;
